"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useEvent;

var _useImmediateEffect = _interopRequireDefault(require("./useImmediateEffect"));

function useEvent(target, name, listener, options) {
  (0, _useImmediateEffect["default"])(function () {
    var handler = function handler(event) {
      return listener && listener(event);
    };

    target.addEventListener(name, handler, options);
    return function () {
      // It seems speechSynthesis.onvoiceschanged still fire after we called removeEventListener.
      // We are protecting this scenario by setting listener to falsy.
      listener = null;
      target.removeEventListener(name, handler, options);
    };
  }, [listener, name, options, target]);
}